import styled from 'styled-components';

import { themeSpace } from 'styles/themeUtils';

export const List = styled.ul`
  width: 100%;
`;

List.displayName = 'List';

export const ListItem = styled.li`
  margin-bottom: ${themeSpace(1)};
`;

ListItem.displayName = 'ListItem';
